module.exports = __webpack_public_path__ + "img/SueloDisperso.1a2b7c3e.jpg";